import { Button, DuplicateIcon, InvisibleIcon, VisibleIcon } from "@bp/ui-components";
import { useState } from "react";
import { showSuccessToast } from "../../../utils/toast";

export function SecretField({ value }: { value: string }) {
  const [revealed, setRevealed] = useState(false);
  const masked = "•".repeat(24);

  const copy = () => {
    void navigator.clipboard?.writeText(value);
    showSuccessToast("Secret kopiert");
  };

  return (
    <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
      <code
        style={{
          flex: 1,
          minWidth: 0,
          fontSize: 13,
          letterSpacing: "0.04em",
          background: "var(--color-grey-lightest)",
          padding: "9px 12px",
          borderRadius: "var(--border-radius-m)",
          overflowX: "auto",
          whiteSpace: "nowrap",
          fontFamily: "ui-monospace, SFMono-Regular, Menlo, monospace",
        }}
      >
        {revealed ? value : masked}
      </code>
      <Button
        hierarchy="tertiary"
        height="s"
        icon={revealed ? <InvisibleIcon /> : <VisibleIcon />}
        ariaLabel={revealed ? "Secret verbergen" : "Secret anzeigen"}
        onClick={() => setRevealed((r) => !r)}
      />
      <Button
        hierarchy="tertiary"
        height="s"
        icon={<DuplicateIcon />}
        ariaLabel="Secret kopieren"
        onClick={copy}
      />
    </div>
  );
}
